import apiFetch from '../apiFetch'

export default function (token, body, fleetId, signType) {
  const queryParamsArray = [
    fleetId ? `fleetId=${fleetId}` : null,
    signType ? `signType=${signType}` : null
  ]

  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )
  return apiFetch({ endPoint: `UnattendedProcess/SetRequestSignDocumentFleet${queryParams}`, method: 'POST', body: body, token: token })
}
